module.exports = __webpack_public_path__ + "static/media/image_partners_1.40bf867b.png";